export default __webpack_public_path__ + "static/media/ACG_Newlogo_b.21ddb2a5.png";